"use client";

import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import ScanIdModal from "./ScanIdModal";

interface ScanIdButtonProps {
  onScanComplete: (data: any) => void;
  variant?: "text" | "outlined" | "contained";
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  disabled?: boolean;
  sx?: any;
  showFullText?: boolean;
}

export default function ScanIdButton({
  onScanComplete,
  variant = "contained",
  size = "large",
  fullWidth = false,
  disabled = false,
  sx = {},
  showFullText = true,
}: ScanIdButtonProps) {
  const [scanIdModal, setScanIdModal] = useState(false);

  const handleScanComplete = (data: any) => {
    setScanIdModal(false);
    onScanComplete(data);
  };

  const defaultStyles = {
    bgcolor: "#10b981",
    color: "white",
    borderRadius: 3,
    px: { xs: 2, sm: 3 },
    py: { xs: 1, sm: 1.5 },
    fontSize: { xs: "0.875rem", sm: "1rem" },
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 4px 14px 0 rgba(16, 185, 129, 0.25)",
    whiteSpace: "nowrap",
    minWidth: { xs: "auto", sm: "auto" },
    "&:hover": {
      bgcolor: "#059669",
      boxShadow: "0 6px 20px 0 rgba(16, 185, 129, 0.35)",
    },
    ...sx,
  };

  return (
    <>
      <Button
        variant={variant}
        onClick={() => setScanIdModal(true)}
        size={size}
        fullWidth={fullWidth}
        disabled={disabled}
        startIcon={<span style={{ fontSize: "1.5rem" }}>📷</span>}
        sx={defaultStyles}
      >
        {showFullText ? (
          <>
            <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
              {Vocabulary.scanIdCard}
            </Box>
            <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
              {Vocabulary.scan}
            </Box>
          </>
        ) : (
          Vocabulary.scan
        )}
      </Button>

      <ScanIdModal
        openModal={scanIdModal}
        handleClose={() => setScanIdModal(false)}
        doneProcess={handleScanComplete}
      />
    </>
  );
}